import dynamic from 'next/dynamic';

import Head from 'next/head';

const Details2 = dynamic(() => import("@components/Components/CheckoutComponent/Details/Details"), {
  ssr: false,
})


const Details = ({detailsData}) => {

  const {brand_settings, template_page_settings, time} = detailsData;
  // const {template_settings} = globalProps;
  //layout setting retrieved from template settings
  // const layout = getSetting(
  //   template_settings,
  //   [],
  //   "checkout_layout",
  //   "wide"
  // );
  
  // const pageLayout = {
  //   checkout_layout_width : template_settings.checkout_layout_width,
  //   layout: template_settings.checkout_layout
  // }
  // const layout_width =getSetting(
  //               template_settings,
  //               pageLayout,
  //               "checkout_layout_width",
  //               "0px"
  //           );


  // return (addLayout(toWrapComponents, layout, layout_width))
  return (
    <>
      <Head>
          <title>{`${process.env.brand.brand_name} - Checkout - Details`}</title>
          <meta
              name="description"
              content={"Confirm your details for an instant online quote"}
          />
      </Head>

      {/* <DetailsComponent
        settingData={brand_settings}
        timeData={time}
        template_page_settings={template_page_settings}
      /> */}
    

      <Details2

          settingData={brand_settings}
          timeData={time}
          template_page_settings={template_page_settings}
      />
    
      
    </>
  )
}

export async function getServerSideProps({query, res}) {
  const detailsReq = await fetch(`${process.env.BASE_API_URL}checkout/details`);
  const detailsData = await detailsReq.json()

  // Pass data to the page via props
  return { 
    props: { detailsData },
  }
}


export default Details